import ShareAttachmentModalContainer from './containers/ShareAttachmentModalContainer'

export default ShareAttachmentModalContainer
